// source: src/common/canvas/tiles/realtime_view.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var src_common_realtime_view_pb = require('../../../../src/common/realtime/view_pb.js');
goog.object.extend(proto, src_common_realtime_view_pb);
var src_common_realtime_query_pb = require('../../../../src/common/realtime/query_pb.js');
goog.object.extend(proto, src_common_realtime_query_pb);
goog.exportSymbol('proto.loupe.common.canvas.tiles.RealtimeViewTile', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.canvas.tiles.RealtimeViewTile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.canvas.tiles.RealtimeViewTile.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.canvas.tiles.RealtimeViewTile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.canvas.tiles.RealtimeViewTile.displayName = 'proto.loupe.common.canvas.tiles.RealtimeViewTile';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.canvas.tiles.RealtimeViewTile.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.canvas.tiles.RealtimeViewTile.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.canvas.tiles.RealtimeViewTile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.canvas.tiles.RealtimeViewTile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.tiles.RealtimeViewTile.toObject = function(includeInstance, msg) {
  var f, obj = {
    view: (f = msg.getView()) && src_common_realtime_view_pb.View.toObject(includeInstance, f),
    userQueryParametersList: jspb.Message.toObjectList(msg.getUserQueryParametersList(),
    src_common_realtime_query_pb.UserQueryParameters.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.canvas.tiles.RealtimeViewTile}
 */
proto.loupe.common.canvas.tiles.RealtimeViewTile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.canvas.tiles.RealtimeViewTile;
  return proto.loupe.common.canvas.tiles.RealtimeViewTile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.canvas.tiles.RealtimeViewTile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.canvas.tiles.RealtimeViewTile}
 */
proto.loupe.common.canvas.tiles.RealtimeViewTile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new src_common_realtime_view_pb.View;
      reader.readMessage(value,src_common_realtime_view_pb.View.deserializeBinaryFromReader);
      msg.setView(value);
      break;
    case 2:
      var value = new src_common_realtime_query_pb.UserQueryParameters;
      reader.readMessage(value,src_common_realtime_query_pb.UserQueryParameters.deserializeBinaryFromReader);
      msg.addUserQueryParameters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.canvas.tiles.RealtimeViewTile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.canvas.tiles.RealtimeViewTile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.canvas.tiles.RealtimeViewTile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.tiles.RealtimeViewTile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getView();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      src_common_realtime_view_pb.View.serializeBinaryToWriter
    );
  }
  f = message.getUserQueryParametersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      src_common_realtime_query_pb.UserQueryParameters.serializeBinaryToWriter
    );
  }
};


/**
 * optional loupe.common.realtime.View view = 1;
 * @return {?proto.loupe.common.realtime.View}
 */
proto.loupe.common.canvas.tiles.RealtimeViewTile.prototype.getView = function() {
  return /** @type{?proto.loupe.common.realtime.View} */ (
    jspb.Message.getWrapperField(this, src_common_realtime_view_pb.View, 1));
};


/**
 * @param {?proto.loupe.common.realtime.View|undefined} value
 * @return {!proto.loupe.common.canvas.tiles.RealtimeViewTile} returns this
*/
proto.loupe.common.canvas.tiles.RealtimeViewTile.prototype.setView = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.canvas.tiles.RealtimeViewTile} returns this
 */
proto.loupe.common.canvas.tiles.RealtimeViewTile.prototype.clearView = function() {
  return this.setView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.canvas.tiles.RealtimeViewTile.prototype.hasView = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated loupe.common.realtime.UserQueryParameters user_query_parameters = 2;
 * @return {!Array<!proto.loupe.common.realtime.UserQueryParameters>}
 */
proto.loupe.common.canvas.tiles.RealtimeViewTile.prototype.getUserQueryParametersList = function() {
  return /** @type{!Array<!proto.loupe.common.realtime.UserQueryParameters>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_realtime_query_pb.UserQueryParameters, 2));
};


/**
 * @param {!Array<!proto.loupe.common.realtime.UserQueryParameters>} value
 * @return {!proto.loupe.common.canvas.tiles.RealtimeViewTile} returns this
*/
proto.loupe.common.canvas.tiles.RealtimeViewTile.prototype.setUserQueryParametersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.loupe.common.realtime.UserQueryParameters=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.realtime.UserQueryParameters}
 */
proto.loupe.common.canvas.tiles.RealtimeViewTile.prototype.addUserQueryParameters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.loupe.common.realtime.UserQueryParameters, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.canvas.tiles.RealtimeViewTile} returns this
 */
proto.loupe.common.canvas.tiles.RealtimeViewTile.prototype.clearUserQueryParametersList = function() {
  return this.setUserQueryParametersList([]);
};


goog.object.extend(exports, proto.loupe.common.canvas.tiles);
